import {
  Box,
  Button,
  Card,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getFeeStructureDetails,
  postFeeStructureDetails,
} from '../../features/mobile/mobileSlice';
import { Spinner } from 'react-bootstrap';
import AddIcon from '@mui/icons-material/Add';
import useNotification from '../../hooks/useNotification';
import ToastNotification from '../UIElements/ToastNotification';
import ClearIcon from '@mui/icons-material/Clear';
import SaveIcon from '@mui/icons-material/Save';
import RestoreIcon from '@mui/icons-material/Restore';
import EditIcon from '@mui/icons-material/Edit';
const FeeStructure = () => {
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [feeStructure, setFeeStructure] = useState([]);
  const [initalFeeStructure, setInitialFeeStructure] = useState([]);
  const datesArray = feeStructure.map((obj) => obj.dueDate);
  const [edit, setEdit] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [resetKey, setResetKey] = useState(false);
  const [sameNameError, setSameNameError] = useState(false);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  async function getFeeStructure() {
    try {
      const response = await dispatch(getFeeStructureDetails()).unwrap();
      response !== 'error' && response.length > 0
        ? (setFeeStructure(response),
          setEdit(true),
          setInitialFeeStructure(response))
        : '';
    } catch {
      alert('Error in Fetching fee Structure');
    } finally {
      setLoading(false);
    }
  }
  function checkErrors(feeStructure) {
    const totalPercentage = feeStructure?.reduce(
      (a, c) => a + (Number(c.percent) || 0),
      0,
    );
    const isSameName =
      new Set(feeStructure?.map((obj) => obj.name))?.size !==
      feeStructure.length;
    setSameNameError(isSameName);
    const noEmptyValues = feeStructure?.every((obj) => {
      return obj.name && obj.dueDate && obj.percent;
    });
    totalPercentage == 100 && noEmptyValues
      ? setIsError(false)
      : setIsError(true);
    return totalPercentage == 100 && noEmptyValues && !isSameName;
  }
  async function handleSubmit() {
    if (checkErrors(feeStructure)) {
      try {
        const response = await dispatch(
          postFeeStructureDetails(feeStructure),
        ).unwrap();
        setFeeStructure(response);
        setInitialFeeStructure(response);
        showSuccess('Fee Configuratin submitted successfully');
        setIsError(false);
        setEdit(true);
        setSameNameError(false);
      } catch {
        showError('Error in Submiting the details');
      }
    } else {
      setIsError(true);
    }
  }
  useEffect(() => {
    getFeeStructure();
  }, []);
  return (
    <div className='max-w-3xl'>
      <Box>
        <Card className='min-h-96 mt-2 rounded-lg p-6'>
          {loading ? (
            <div className='flex flex-col gap-2 items-center min-h-96 justify-center '>
              <Spinner></Spinner>

              <p>Fetching Fee Strucutre Details</p>
            </div>
          ) : (
            <>
              <Typography
                variant='h6'
                color='primary'
                className='mb-2 font-medium '
              >
                Fee Configuration Structure :
              </Typography>
              {feeStructure.length === 0 && (
                <div>
                  <Typography>
                    Please configure the Tution Fee Structure like Term1,DueDate
                    and Percentage of Total Fee.
                  </Typography>{' '}
                  <span>
                    <b>Note:</b>Total Percentage must be equal to 100
                  </span>
                  <br />
                  <div className='flex gap-2  items-center mt-4'>
                    <IconButton
                      className='bg-blue-600 text-white font-bold'
                      aria-label='delete'
                      size='small'
                      onClick={() =>
                        setFeeStructure((prev) => [
                          ...prev,
                          {
                            id: parseInt(Date.now() / 1000),
                            name: '',
                            dueDate: '',
                            percent: '',
                          },
                        ])
                      }
                    >
                      <AddIcon />
                    </IconButton>

                    <Typography>
                      click the button to add a fee details
                    </Typography>
                  </div>
                </div>
              )}
              {feeStructure.map((obj) => (
                <Fields
                  key={obj.id}
                  obj={obj}
                  isError={isError}
                  feeStructure={feeStructure}
                  setFeeStructure={setFeeStructure}
                  edit={edit}
                  resetKey={resetKey}
                  checkErrors={checkErrors}
                  datesArray={datesArray}
                  setIsCancel={setIsCancel}
                  isCancel={isCancel}
                ></Fields>
              ))}
              {sameNameError && (
                <div className='my-1 text-red-600'>
                  Note: Fee Names should not be same.{' '}
                </div>
              )}
              <div className='max-w-[700px] flex justify-between'>
                {/* AddIcon */}
                <div>
                  {feeStructure.length > 0 && (
                    <IconButton
                      className={`${edit ? 'bg-gray-300' : 'bg-blue-600'} text-white font-bold `}
                      aria-label='delete'
                      size='small'
                      disabled={edit}
                      onClick={() =>
                        setFeeStructure((prev) => [
                          ...prev,
                          {
                            id: Math.floor(10000 + Math.random() * 90000),
                            name: '',
                            dueDate: '',
                            percent: '',
                          },
                        ])
                      }
                    >
                      <AddIcon />
                    </IconButton>
                  )}
                </div>
                <div className='col-span-2    text-end  pr-6'>
                  {/* SUBMITBUTTON */}
                  {edit && initalFeeStructure.length > 0 ? (
                    <Button
                      startIcon={<EditIcon />}
                      variant='contained'
                      onClick={() => setEdit(false)}
                    >
                      {' '}
                      Edit{' '}
                    </Button>
                  ) : (
                    <div>
                      {(isCancel || isError) &&
                        initalFeeStructure.length > 0 && (
                          <Button
                            startIcon={<RestoreIcon />}
                            variant='contained'
                            color='error'
                            onClick={() => {
                              setFeeStructure(initalFeeStructure);
                              (setIsCancel(false),
                                setEdit(false),
                                setResetKey((Prev) => !Prev));
                              setIsError(false);
                            }}
                          >
                            Revert
                          </Button>
                        )}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {feeStructure.length > 0 && (
                        <Button
                          startIcon={<SaveIcon />}
                          className='ml-auto'
                          color='success'
                          variant='contained'
                          onClick={handleSubmit}
                        >
                          save
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Error */}
              {sameNameError && isError && feeStructure.length > 0 && (
                <div className='text-red-500 mt-2 mb-4'>
                  <b>Note : </b>1.Sum of total Percentages must be equal to 100
                  . <br></br>
                  <b className='text-white'>Note : </b> 2. Enter values in all
                  fields.
                </div>
              )}
              {initalFeeStructure.length > 0 && (
                <div className='my-10'>
                  <Typography
                    variant='h6'
                    color='primary'
                    className='mb-2 font-medium '
                  >
                    Tution Fee Structure :
                  </Typography>
                  <TableContainer
                    component={Paper}
                    variant='outlined'
                    sx={{
                      maxHeight: '50vh',
                      maxWidth: '700px',
                      overflow: 'auto',
                    }}
                  >
                    <Table
                      stickyHeader
                      size='small'
                      sx={{ minWidth: 500, maxWidth: '700px' }}
                    >
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                          <TableCell>
                            <strong>SNo.</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Fee Type</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Due Date</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Percentage of Fee</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {initalFeeStructure?.map((obj, index) => (
                          <TableRow
                            key={obj.id}
                            hover
                            sx={{
                              '&:nth-of-type(odd)': {
                                backgroundColor: '#fafafa',
                              },
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{obj.name}</TableCell>
                            <TableCell>{arrangeDate(obj.dueDate)}</TableCell>
                            <TableCell>{obj?.percent}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          )}
        </Card>
      </Box>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </div>
  );
};
export default FeeStructure;

function arrangeDate(d) {
  return d.split('-').reverse().join('-');
}
const Fields = ({
  obj,
  isError,
  feeStructure,
  setFeeStructure,
  edit,
  resetKey,
  datesArray,
  setIsCancel,
  checkErrors,
  isCancel,
}) => {
  const [dateError, setDateError] = useState('');
  function handleChange(newObj) {
    setFeeStructure((prev) =>
      prev.map((obj) => (obj.id === newObj.id ? newObj : obj)),
    );
  }
  function handleRemove(DelObj) {
    setFeeStructure((prev) => prev.filter((obj) => obj.id !== DelObj.id));
  }

  function handledueDates(oldDate, newDate) {
    const index = datesArray.indexOf(oldDate);
    if (index == 0 && datesArray.length > 0) {
      if (new Date(newDate) >= new Date(datesArray[1]))
        return `Date must before the ${arrangeDate(datesArray[1])}`;
      else return '';
    } else if (index == datesArray.length - 1 && datesArray.length > 0) {
      if (new Date(newDate) <= new Date(datesArray[index - 1]))
        return `Date must after the ${arrangeDate(datesArray[index - 1])}`;
      else return '';
    } else if (index > 0 && index < datesArray.length) {
      if (
        new Date(newDate) <= new Date(datesArray[index - 1]) ||
        new Date(newDate) >= new Date(datesArray[index + 1])
      )
        return `Date must betwen the ${datesArray[index - 1] ? arrangeDate(datesArray[index - 1]) : 'Previous One'} and  ${datesArray[index + 1] ? arrangeDate(datesArray[index + 1]) : 'Next One'}`;
      else return '';
    } else if (index == 0 && datesArray.length - 1 == index) {
      return '';
    }
  }
  useEffect(() => {
    setDateError('');
  }, [resetKey]);
  return (
    <>
      <div className='max-w-[700px] grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2 mb-4'>
        <TextField
          label='Fee Name'
          size='small'
          disabled={edit}
          placeholder='eg:Term1'
          error={isError && !obj.name}
          helperText={isError && !obj.name ? 'Enter name' : ''}
          value={obj.name}
          onChange={(e) => handleChange({ ...obj, name: e.target.value })}
          InputLabelProps={{
            shrink: true,
          }}
        ></TextField>
        <TextField
          type='date'
          error={(isError && !obj.dueDate) || (dateError && isCancel)}
          helperText={
            isError && !obj.dueDate
              ? 'Select DueDate'
              : dateError && isCancel
                ? dateError
                : ''
          }
          label='DueDate'
          size='small'
          disabled={edit}
          value={obj.dueDate}
          onChange={(e) => {
            const check = handledueDates(obj.dueDate, e.target.value);
            check
              ? (handleChange({ ...obj, dueDate: '' }),
                setDateError(check),
                setIsCancel(true))
              : (handleChange({ ...obj, dueDate: e.target.value }),
                setDateError(check),
                setIsCancel(false));
          }}
          InputLabelProps={{
            shrink: true,
          }}
        ></TextField>

        <div className='flex items-start gap-2 '>
          <TextField
            className='flex-1'
            label='% of Fee'
            disabled={edit}
            error={isError && !obj.percent}
            helperText={isError && !obj.percent ? 'Enter percent' : ''}
            type='number'
            size='small'
            sx={{
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                {
                  display: 'none',
                },
            }}
            onKeyDown={(e) => {
              if (['-', '+', 'e', 'E', '.'].includes(e.key)) {
                e.preventDefault(); // block minus, plus, and scientific notation
              }
            }}
            placeholder='eg:20'
            value={obj.percent}
            onChange={(e) => {
              const value = e.target.value;
              const finalValue = value > 100 ? 100 : value;
              handleChange({
                ...obj,
                percent: finalValue > 0 ? finalValue : '',
              });
            }}
            InputLabelProps={{
              min: 1,
              max: 1000,
              inputMode: 'numeric',
              pattern: '[0-9]*',
              shrink: true,
            }}
          ></TextField>
          <IconButton
            disabled={edit}
            className={`${edit ? 'bg-gray-300' : 'bg-red-600'} text-white font-bold size-5 self-center`}
            aria-label='delete'
            size='small'
            onClick={() => {
              (handleRemove(obj),
                checkErrors(feeStructure.filter((a) => a.id !== obj.id)));
            }}
          >
            <ClearIcon className='size-4' />
          </IconButton>
        </div>
      </div>
    </>
  );
};
